// angular
import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
// services
import { StateManagementService } from '@app/+chat/shared/services/state-management.service';
import { ProductsService } from '@app/+products/shared/services/products.service';
// interfaces
import {
  IBusiness,
  IBusinessContactInfo,
} from '@app/+suppliers/shared/interfaces/business.interface';
import { IBusinessContactForm } from '../interfaces/business-contact-form.interface';

@Injectable()
export class PortfolioService {
  // states
  public portfolioData = signal<IBusiness>({});
  public isPortfolioLoading = signal<boolean>(false);
  public portfolioContactInfo = signal<IBusinessContactInfo>({});

  // dependencies
  private readonly _httpClient = inject(HttpClient);
  private readonly _stateManagement = inject(StateManagementService);
  private readonly _productsService = inject(ProductsService);
  private readonly _router = inject(Router);
  constructor() {}

  // fetch business or customer details data
  public getPortfolioData(custom_url: string) {
    // set loading state
    this.isPortfolioLoading.set(true);
    return this._httpClient
      .get<IBusiness>(`main/businesses/custom-url/${custom_url}`)
      .subscribe({
        next: (res: IBusiness) => {
          // fetch business top-products
          res?.custom_url &&
            this._productsService.getBusinessTopProducts(res?.custom_url);
          res?._id && this.getPortfolioContactInfo(res?._id);

          const people = res?.people?.map(member => ({
            ...member,
          }));

          const customizedData = {
            ...res,
            people,
            is_verified: true,
          };
          this.portfolioData.set(customizedData);

          // set business id for chat
          this._stateManagement.businessChatData.set(customizedData);
          res?._id && this._stateManagement.businessId.set(res._id);
        },
        error: err => {
          this.isPortfolioLoading.set(false);
          if (err.status === 404) {
            this._router.navigate(['404']);
          }
        },
        complete: () => {
          this.isPortfolioLoading.set(false);
        },
      });
  }

  public getPortfolioContactInfo(id: string) {
    return this._httpClient
      .get<IBusinessContactInfo>(`main/businesses/${id}/contact-info`)
      .subscribe({
        next: (res: IBusinessContactInfo) => {
          this.portfolioContactInfo.set(res);
        },
        error: err => {},
        complete: () => {},
      });
  }

  private _postBusinessContactForm(data: IBusinessContactForm) {
    return this._httpClient.post('main/messages', { ...data });
  }

  public submitBusinessContactForm(data: IBusinessContactForm) {
    return this._postBusinessContactForm(data);
  }
}
